import { attr, belongsTo, hasMany } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'
import placeholder from '../assets/placeholder_elementary.png'

const Pose = ApplicationRecord.extend({
  static: {
    jsonapiType: 'poses',
  },
  attrs: {
    extension: attr(),
    selectedForYearbook: attr(),
    // Read-only: the official yearbook pose of record (Pose#is_yearbook_pose).
    // Used by the senior yearbook-selection step to pre-highlight an existing choice.
    isYearbookPose: attr({ persist: false }),
    // Read-only garment-classifier verdict for yearbook eligibility (true/false/null).
    // The yearbook-selection step orders eligible poses first and blocks selecting an
    // ineligible one (explicit false); fail-open on null.
    yearbookAcceptable: attr({ persist: false }),
    // Read-only garment category (tuxedo/black_drape/cap_and_gown/street_clothes/other/null)
    // behind yearbookAcceptable. Drives the senior gallery's 3-way ordering.
    yearbookAttire: attr({ persist: false }),
    url: attr(),
    index: attr(),
    createdAt: attr(),
    type: attr({ persist: false }),
    updatedAt: attr(),
    imageUrl: attr(),
    rotatedUrl: attr(),
    folder: attr(),
    rotatedWatermarkUrl: attr(),
    imageFileName: attr(),
    number: attr(),
    watermarkUrl: attr(),
    // One of the photographer's own sport uploads (Pose#sport_upload_slot?).
    sportUploadSlot: attr(),
    // 'team' / 'buddy' / 'individual' for a sport upload slot (Pose.sport_slot_kind).
    sportSlotKind: attr(),
    studentImage: belongsTo(),
    sheets: hasMany(),
    addonSheets: hasMany(),
  },
  methods: {
    image() {
      let res = placeholder

      if (this.imageUrl) res = this.imageUrl
      else if (this.watermarkUrl) res = this.watermarkUrl

      return res
    },
    watermark() {
      if (this.watermarkUrl) return this.watermarkUrl

      return placeholder
    },
    isPNG() {
      return this.imageUrl && this.imageUrl.toLowerCase().includes('.png');
    }
  },
})

export default Pose
